// ------------------------------------
// props 輸入需求 :
// props.isON : boolean                                   ( 元件開關 )
// props.setReturnShift : function( params : str )        ( 回傳 : str ('morn', 'mid', 'night') )
// ------------------------------------

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Account from '../../../../actions/Account';

const FordaysSwitch = (props) => {
  const { t } = useTranslation(); // 1.2 i18n

  const [fordaysOpen, setFordaysOpen] = useState();
  function togglefordaysOpen() {
    setFordaysOpen(!fordaysOpen);
  }
  const fordays_show = props.days_open === 'TODAY' ? t('HISTORY_RECORD.TODAY') : t('HISTORY_RECORD.FORDAYS');

  function clickFordays(e) {
    props.setDays_open(e.target.id);
  }

  return (
    <div className="col-4 fx-ccc ">
      <div className="top-tag fx-d-r mar-l">
        <div className="name fx-ccc">{t('HISTORY_RECORD.RANGE')}</div>
        <div className="body h-50">
          <div className="inner" onClick={togglefordaysOpen}>
            {fordays_show}
          </div>
          {fordaysOpen && (
            <div className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def" onClick={togglefordaysOpen}>
              <div className="pos-a shift">
                <div id="TODAY" className="individual" onClick={clickFordays}>
                  {t('HISTORY_RECORD.TODAY')}
                </div>
                <div id="FORDAYS" className="individual" onClick={clickFordays}>
                  {t('HISTORY_RECORD.FORDAYS')}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default FordaysSwitch;
